import React from 'react';
export function TermsContent() {
  return <div className="space-y-6" data-id="element-1604">
      <section data-id="element-1605">
        <h4 className="text-lg font-bold text-white mb-2" data-id="element-1606">1. Introducción</h4>
        <p data-id="element-1607">
          Bienvenido a Estrategias Digitales A-Z. Al contratar nuestros
          servicios de diseño y desarrollo web, usted acepta los siguientes
          términos y condiciones. Estos términos rigen la relación comercial
          entre el cliente y Estrategias Digitales A-Z, operando bajo las leyes
          de la República de Costa Rica.
        </p>
      </section>

      <section data-id="element-1608">
        <h4 className="text-lg font-bold text-white mb-2" data-id="element-1609">2. Servicios</h4>
        <p data-id="element-1610">
          Nos especializamos en la creación de páginas web, diseño web y
          estrategias digitales. El alcance específico de cada proyecto (tiempos
          de entrega, número de revisiones y entregables) se detalla en el plan
          seleccionado (Mis Primeros Pasos, Despegue Digital o Dominio Total) o
          en la propuesta personalizada acordada.
        </p>
      </section>

      <section data-id="element-1611">
        <h4 className="text-lg font-bold text-white mb-2" data-id="element-1612">
          3. Pagos y Tarifas
        </h4>
        <p data-id="element-1613">
          Para iniciar cualquier proyecto, se requiere el pago acordado según el
          plan seleccionado. Aceptamos pagos mediante transferencia bancaria
          (SINPE Móvil/IBAN en Costa Rica), tarjeta de crédito/débito y PayPal.
        </p>
        <ul className="list-disc pl-5 mt-2 space-y-1" data-id="element-1614">
          <li data-id="element-1615">Los precios están expresados en Dólares Americanos (USD).</li>
          <li data-id="element-1616">
            No se realizarán reembolsos una vez iniciado el trabajo de diseño,
            salvo incumplimiento comprobable por parte de nuestra agencia.
          </li>
        </ul>
      </section>

      <section data-id="element-1617">
        <h4 className="text-lg font-bold text-white mb-2" data-id="element-1618">
          4. Propiedad Intelectual
        </h4>
        <p data-id="element-1619">
          Una vez finalizado el proyecto y cubierto el pago total, el cliente
          obtiene los derechos de uso sobre el diseño final y los contenidos
          entregados. Estrategias Digitales A-Z se reserva el derecho de mostrar
          el trabajo realizado en su portafolio y materiales promocionales, a
          menos que se acuerde un acuerdo de confidencialidad (NDA) por escrito.
        </p>
      </section>

      <section data-id="element-1620">
        <h4 className="text-lg font-bold text-white mb-2" data-id="element-1621">
          5. Revisiones y Cambios
        </h4>
        <p data-id="element-1622">
          Cada plan incluye un número específico de rondas de revisión. Cambios
          adicionales fuera del alcance original o que excedan las rondas
          estipuladas se facturarán por separado a nuestra tarifa por hora
          vigente.
        </p>
      </section>

      <section data-id="element-1623">
        <h4 className="text-lg font-bold text-white mb-2" data-id="element-1624">
          6. Limitación de Responsabilidad
        </h4>
        <p data-id="element-1625">
          Estrategias Digitales A-Z no se hace responsable por pérdidas
          indirectas, lucro cesante o daños derivados del uso del sitio web
          entregado. El cliente es responsable de asegurar que el contenido
          proporcionado para su sitio (textos, imágenes, logos) no infrinja
          derechos de terceros.
        </p>
      </section>

      <section data-id="element-1626">
        <h4 className="text-lg font-bold text-white mb-2" data-id="element-1627">7. Jurisdicción</h4>
        <p data-id="element-1628">
          Cualquier disputa relacionada con estos términos se regirá por las
          leyes de Costa Rica y se intentará resolver primero mediante
          conciliación amistosa antes de proceder a instancias legales en San
          José, Costa Rica.
        </p>
      </section>

      <div className="pt-4 text-sm text-gray-500 border-t border-white/10" data-id="element-1629">
        Última actualización: Febrero 2026
      </div>
    </div>;
}